<div class="toast-container" :class="type">
    <span class="material-icons icon">
      {{ icon }}
    </span>
    <span class="message">{{ message }}</span>
    <span class="material-icons icon-close" @click="emitClose()">
      close
    </span>
  </div>